"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionBar = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var styles = __importStar(require("./PromotionBar.css"));
var classnames_1 = __importDefault(require("classnames"));
var moment_1 = __importDefault(require("moment"));
var zod_1 = require("zod");
var pages_common_1 = require("@qwilr/pages-common");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var promotionLocalStorageKey = "qwilr:dismissed-promotion-bar-august2024";
var PromotionContent = function () {
    return (react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true, theme: "dark", align: "center" },
        "Meet \u2728Agreements\u2728 Include plain-text, print-friendly contracts, T&Cs and more within your Qwilr pages. Learn",
        " ",
        react_1.default.createElement(kaleidoscope_1.Link, { target: "_blank", href: "https://qwilr.com/blog/new-in-qwilr-agreements?utm_source=qwilr_app&utm_medium=promotional_strip&utm_campaign=agreements_launch" }, "more")));
};
var PromotionBar = function (_a) {
    var usingFeature = _a.usingFeature, user = _a.user, isTrial = _a.isTrial;
    var _b = __read((0, pages_common_1.useLocalStorage)({
        key: promotionLocalStorageKey,
        schema: zod_1.z.boolean(),
        default: false,
    }), 2), isDismissed = _b[0], setIsDismissed = _b[1];
    var agreementReleaseConditions = userCreatedBeforeCutoff(user.createdAt) && !isTrial;
    var showPromotion = usingFeature(FeatureFlag_1.default.PromotionBar) && !isDismissed && agreementReleaseConditions;
    if (showPromotion) {
        return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", justify: "center", align: "center", paddingTop: "xs", paddingBottom: "xs", paddingLeft: "xs", paddingRight: "xl", className: (0, classnames_1.default)(tokens_1.darkTheme, styles.promotionBar) },
            react_1.default.createElement(PromotionContent, null),
            react_1.default.createElement(kaleidoscope_1.IconButton, { isIconOnly: true, icon: react_1.default.createElement(icons_1.Close, null), "aria-label": "dismiss", className: styles.closeButton, size: kaleidoscope_1.ButtonSize.Small, onClick: function () {
                    setIsDismissed(true);
                } })));
    }
    return null;
};
exports.PromotionBar = PromotionBar;
var userCreatedBeforeCutoff = function (userCreatedAt) {
    var cutoffDate = (0, moment_1.default)("2024-08-05T00:50:00.000Z");
    return (0, moment_1.default)(userCreatedAt).isBefore(cutoffDate);
};
